/*
 * Control page content scrolling
 */
import { addClass, removeClass, browserScrollbarSize } from '../../../core/utils/src/dom';
var modalOpenClass = 'awsui-modal-open';
var initialBodyPaddingRightStyle = null;
export function disableBodyScrolling() {
    setBodyScrollbarPadding();
    addClass(document.body, modalOpenClass);
}
export function enableBodyScrolling() {
    removeClass(document.body, modalOpenClass);
    restoreBodyScrollbarPadding();
}
function setBodyScrollbarPadding() {
    if (bodyHasScrollbar()) {
        initialBodyPaddingRightStyle = document.body.style.paddingRight;
        var initialBodyPaddingRight = computedBodyPaddingRightPixels();
        var scrollbarWidth = browserScrollbarSize().width;
        var newBodyPaddingRight = initialBodyPaddingRight + scrollbarWidth;
        document.body.style.paddingRight = newBodyPaddingRight + 'px';
    }
}
function computedBodyPaddingRightPixels() {
    return parseInt(window.getComputedStyle(document.body).paddingRight, 10);
}
function restoreBodyScrollbarPadding() {
    if (initialBodyPaddingRightStyle) {
        document.body.style.paddingRight = initialBodyPaddingRightStyle;
    }
    else {
        document.body.style.removeProperty('padding-right');
    }
    initialBodyPaddingRightStyle = null;
}
function bodyHasScrollbar() {
    // Unfortunately this difference doesn't appear to match the scrollbar width during testing,
    // otherwise we could remove browserScrollbarSize().  Bootstrap also doesn't use this difference
    // directly.
    return document.body.clientWidth < window.innerWidth;
}
//# sourceMappingURL=BodyScroll.js.map